'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isNotNil(x) {
    return x != null;
}

exports.isNotNil = isNotNil;
